<p-button type="button" (click)="onConfigButtonClick()" icon="pi pi-cog" styleClass="layout-config-button"></p-button>

<p-sidebar [(visible)]="visible" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'">
  <div class="p-3">
    <ng-container *ngIf="!minimal">
      <h5>Menu Mode</h5>
      <div class="flex gap-4">
        <div class="field-radiobutton flex-1">
          <p-radioButton name="mode" value="static" [(ngModel)]="menuMode" inputId="mode1"></p-radioButton>
          <label for="mode1">Static</label>
        </div>
<!--        <div class="field-radiobutton flex-1">-->
<!--          <p-radioButton name="mode" value="overlay" [(ngModel)]="menuMode" inputId="mode2"></p-radioButton>-->
<!--          <label for="mode2">Overlay</label>-->
<!--        </div>-->
      </div>
<!--      <div class="flex gap-4">-->
<!--        <div class="field-radiobutton flex-1">-->
<!--          <p-radioButton name="mode" value="reveal" [(ngModel)]="menuMode" inputId="mode5"></p-radioButton>-->
<!--          <label for="mode5">Reveal</label>-->
<!--        </div>-->
<!--      </div>-->
    </ng-container>

    <ng-container *ngIf="!minimal">
      <h5>Menu Themes</h5>
      <p *ngIf="colorScheme === 'dark';else menu_theme_selector">Menu themes are only available in light mode by design
        as large surfaces can emit too much brightness in dark mode.</p>
      <ng-template #menu_theme_selector>
        <div class="flex flex-wrap row-gap-3 pb-3">
          <div class="w-3" *ngFor="let theme of menuThemes">
            <button type="button"
                    class="cursor-pointer p-link w-2rem h-2rem border-round shadow-2 flex-shrink-0 flex justify-content-center align-items-center border-circle"
                    (click)="changeMenuTheme(theme.name)"
                    [ngStyle]="{'background-color': theme.color}"><i *ngIf="menuTheme === theme.name"
                                                                     class="pi pi-check text-lg"
                                                                     [ngClass]="{'text-white': menuTheme !== 'light'}"></i>
            </button>
          </div>
        </div>
      </ng-template>

      <h5>Topbar Themes</h5>
      <div class="flex flex-wrap row-gap-3 pb-3">
        <div class="w-3" *ngFor="let theme of topbarThemes">
          <button type="button"
                  class="cursor-pointer p-link w-2rem h-2rem border-round shadow-2 flex-shrink-0 flex justify-content-center align-items-center border-circle"
                  (click)="changeTopbarTheme(theme.name)"
                  [ngStyle]="{'background-color': theme.color}"><i *ngIf="topbarTheme === theme.name"
                                                                   class="pi pi-check text-lg"
                                                                   [ngClass]="{'text-white': topbarTheme !== 'white'}"></i>
          </button>
        </div>
      </div>
    </ng-container>

    <h5>Component Themes</h5>
    <div class="flex flex-wrap row-gap-3">
      <div class="w-3" *ngFor="let theme of componentThemes">
        <button type="button"
                class="cursor-pointer p-link w-2rem h-2rem border-round shadow-2 flex-shrink-0 flex justify-content-center align-items-center border-circle"
                (click)="changeTheme(theme.name)"
                [ngStyle]="{'background-color': theme.color}"><i *ngIf="componentTheme === theme.name"
                                                                 class="pi pi-check text-lg text-white"></i></button>
      </div>
    </div>
  </div>
</p-sidebar>
